export const APPNAME = "Leopos"
export const PRIMARYCOLOR = "#fa541c"
export const SECONDARYCOLOR = "royalblue"
export const TEXTCOLOR = '#5b5b5b'
export const NAME_SISTEMA = "LEO"
export const MP_PK_SANDBOX = "TEST-91869032-4ab6-4889-a7eb-92e6e2980a12"
export const MP_AT_SANDBOX = "TEST-23856490837356-052212-b26477a9053b74b502dc8ec42da3bd1f-1482300"


